import * as Dtos from "../dtos/Tmd.dtos";
import {  IFormFilter } from "../reducers/index";

export const
    LoadInstitutionItemTemplateCategory: IInstitutionItemTemplateCategoryLoadActionCreator = () => {
        return {
            type: ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_LOAD
        }
    },
    LoadInstitutionItemTemplateCategoryById: IInstitutionItemTemplateCategoryLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_LOAD_BY_ID,
            id
        }
    },
    LoadSuccess: IInstitutionItemTemplateCategoryLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: IInstitutionItemTemplateCategoryLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveInstitutionItemTemplateCategory: IInstitutionItemTemplateCategorySaveActionCreator = (formData) => {
        return {
            type: ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_SAVE,
            formData
        }
    },
    SaveSuccess: IInstitutionItemTemplateCategorySaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: IInstitutionItemTemplateCategorySaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_SAVE_FAILURE,
            responseStatus
        }
    },

    CreateInstitutionItemTemplateCategory: IInstitutionItemTemplateCategoryCreateActionCreator = () => {

        return {
            type: ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_CREATE
        }
    },
    CreateSuccess: IInstitutionItemTemplateCategoryCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: IInstitutionItemTemplateCategoryCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_CREATE_FAILURE,
            responseStatus
        }
    },

    ValidateInstitutionItemTemplateCategory: IInstitutionItemTemplateCategoryValidateActionCreator = (formData) => {
        return {
            type: ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_VALIDATE,
            formData
        }
    },
    ValidateSuccess: IInstitutionItemTemplateCategoryValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: IInstitutionItemTemplateCategoryValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_VALIDATE_FAILURE,
            responseStatus
        }
    },

    Clear: IInstitutionItemTemplateCategoryClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_CLEAR,
            propertiesToClear
        }
    },
    Filter: IInstitutionItemTemplateCategoryFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_FILTER,
            formFilter
        }
    };



export const
    ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_LOAD = "ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_LOAD",
    ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_LOAD_BY_ID = "ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_LOAD_BY_ID",
    ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_LOAD_SUCCESS = "ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_LOAD_SUCCESS",
    ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_LOAD_FAILURE = "ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_LOAD_FAILURE",

    ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_SAVE = "ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_SAVE",
    ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_SAVE_SUCCESS = "ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_SAVE_SUCCESS",
    ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_SAVE_FAILURE = "ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_SAVE_FAILURE",

    ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_CREATE = "ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_CREATE",
    ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_CREATE_SUCCESS = "ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_CREATE_SUCCESS",
    ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_CREATE_FAILURE = "ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_CREATE_FAILURE",

    ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_VALIDATE = "ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_VALIDATE",
    ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_VALIDATE_SUCCESS = "ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_VALIDATE_SUCCESS",
    ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_VALIDATE_FAILURE = "ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_VALIDATE_FAILURE",

    ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_CLEAR = "ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_CLEAR",

    ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_FILTER = "ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_FILTER";

export interface IInstitutionItemTemplateCategoryLoadAction {
    type: "ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_LOAD";
}

export interface IInstitutionItemTemplateCategoryLoadActionCreator {
    (): IInstitutionItemTemplateCategoryLoadAction;
}

export interface IInstitutionItemTemplateCategoryLoadSuccessAction {
    type: "ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_LOAD_SUCCESS";
    formData: Dtos.InstitutionItemTemplateCategory | Dtos.InstitutionItemTemplateCategory[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface IInstitutionItemTemplateCategoryLoadSuccessActionCreator {
    (
        formData: Dtos.InstitutionItemTemplateCategory | Dtos.InstitutionItemTemplateCategory[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): IInstitutionItemTemplateCategoryLoadSuccessAction;
}

export interface IInstitutionItemTemplateCategoryLoadFailureAction {
    type: "ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface IInstitutionItemTemplateCategoryLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IInstitutionItemTemplateCategoryLoadFailureAction;
}

export interface IInstitutionItemTemplateCategoryLoadByIdAction {
    type: "ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_LOAD_BY_ID";
    id: number;
}

export interface IInstitutionItemTemplateCategoryLoadByIdActionCreator {
    (id: number): IInstitutionItemTemplateCategoryLoadByIdAction;
}


export interface IInstitutionItemTemplateCategorySaveAction {
    type: "ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_SAVE";
    formData: Dtos.InstitutionItemTemplateCategory;

}

export interface IInstitutionItemTemplateCategorySaveActionCreator {
    (
        formData: Dtos.InstitutionItemTemplateCategory
    ): IInstitutionItemTemplateCategorySaveAction;
}

export interface IInstitutionItemTemplateCategorySaveSuccessAction {
    type: "ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_SAVE_SUCCESS";
    formData: Dtos.InstitutionItemTemplateCategory;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IInstitutionItemTemplateCategorySaveSuccessActionCreator {
    (
        formData: Dtos.InstitutionItemTemplateCategory,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IInstitutionItemTemplateCategorySaveSuccessAction;
}

export interface IInstitutionItemTemplateCategorySaveFailureAction {
    type: "ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IInstitutionItemTemplateCategorySaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IInstitutionItemTemplateCategorySaveFailureAction;
}

export interface IInstitutionItemTemplateCategoryCreateAction {
    type: "ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_CREATE"
}

export interface IInstitutionItemTemplateCategoryCreateActionCreator {
    (): IInstitutionItemTemplateCategoryCreateAction
}

export interface IInstitutionItemTemplateCategoryCreateSuccessAction {
    type: "ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_CREATE_SUCCESS";
    formData: Dtos.InstitutionItemTemplateCategory;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
}

export interface IInstitutionItemTemplateCategoryCreateSuccessActionCreator {
    (
        formData: Dtos.InstitutionItemTemplateCategory,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): IInstitutionItemTemplateCategoryCreateSuccessAction;
}

export interface IInstitutionItemTemplateCategoryCreateFailureAction {
    type: "ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IInstitutionItemTemplateCategoryCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IInstitutionItemTemplateCategoryCreateFailureAction;
}

export interface IInstitutionItemTemplateCategoryValidateAction {
    type: "ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_VALIDATE";
    formData: Dtos.InstitutionItemTemplateCategory;

}

export interface IInstitutionItemTemplateCategoryValidateActionCreator {
    (
        formData: Dtos.InstitutionItemTemplateCategory
    ): IInstitutionItemTemplateCategoryValidateAction;
}

export interface IInstitutionItemTemplateCategoryValidateSuccessAction {
    type: "ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_VALIDATE_SUCCESS";
    formData: Dtos.InstitutionItemTemplateCategory;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IInstitutionItemTemplateCategoryValidateSuccessActionCreator {
    (
        formData: Dtos.InstitutionItemTemplateCategory,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IInstitutionItemTemplateCategoryValidateSuccessAction;
}

export interface IInstitutionItemTemplateCategoryValidateFailureAction {
    type: "ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IInstitutionItemTemplateCategoryValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IInstitutionItemTemplateCategoryValidateFailureAction;
}

export interface IInstitutionItemTemplateCategoryClearAction {
    type: "ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_CLEAR";
    propertiesToClear?: string[];
}

export interface IInstitutionItemTemplateCategoryClearActionCreator {
    (propertiesToClear?: string[]): IInstitutionItemTemplateCategoryClearAction;
}

export interface IInstitutionItemTemplateCategoryFilterActionCreator {
    (formFilter: IFormFilter): IInstitutionItemTemplateCategoryFilterAction;
}

export interface IInstitutionItemTemplateCategoryFilterAction {
    type: "ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_FILTER";
    formFilter: IFormFilter;
}

export type InstitutionItemTemplateCategoryAction =
    IInstitutionItemTemplateCategoryLoadAction |
    IInstitutionItemTemplateCategoryLoadByIdAction |
    IInstitutionItemTemplateCategoryLoadFailureAction |
    IInstitutionItemTemplateCategoryLoadSuccessAction |
    IInstitutionItemTemplateCategorySaveAction |
    IInstitutionItemTemplateCategorySaveSuccessAction |
    IInstitutionItemTemplateCategorySaveFailureAction |
    IInstitutionItemTemplateCategoryCreateAction |
    IInstitutionItemTemplateCategoryCreateSuccessAction |
    IInstitutionItemTemplateCategoryCreateFailureAction |
    IInstitutionItemTemplateCategoryValidateAction |
    IInstitutionItemTemplateCategoryValidateSuccessAction |
    IInstitutionItemTemplateCategoryValidateFailureAction |
    IInstitutionItemTemplateCategoryClearAction |
    IInstitutionItemTemplateCategoryFilterAction;
